/**
 * Parameters:
 *
 *  data-sw-list-chooser-model-type="<model type>"
 *
 *    Which js model are we choosing for
 *
 *
 *  data-sw-list-chooser-model-id="<model id>"
 *
 *    Id attr of the model
 *
 *
 *  data-sw-list-chooser-list-property="<property name>"
 *
 *    Property of the js model to enumerate
 *    
 *    
 *  data-sw-list-chooser-option-<view data key>="<list property key>"
 *
 *    Maps the list property value of <list property key> to <view data key>
 *
 *
 *  data-sw-list-chooser-select-action="<action name>"
 *
 *    Action to dispatch on select
 *
 *
 *  data-sw-list-chooser-deselect-action="<action name>"
 *
 *    Action to dispatch on deselect
 *
 *  data-sw-list-chooser-options-template="<template key>"
 *
 *    Key for template
 *
 *  data-sw-list-chooser-data-attr-map-<view data key> = "<data attribute>"
 *
 *    Maps data attributes to their view data key, so that you can map additional
 *    information from the chooser to the list template (for when you're not using a simple dropdown)
 *
 *
 *  data-sw-list-chooser-current-options-model-prop="<property name>"
 *
 *    Property of current dropdown options. If listed, listens to changes on this prop to update the dropdown.
 *
 *  data-sw-list-chooser-disabled-class="<CSS class name>"
 *
 *    Disabled class to toggle on list elements when not using a dropdown.
 *
 *  data-sw-list-chooser-chooser-updated-event="<Event name>"
 *
 *    Event name to listen to after a chooser has been rendered (via ajax or a dynamic interaction).
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  require([
    'js/lib/models/ModelManager',
    'js/lib/views/ListChooserView',
    'js/lib/sw-utils',
    'underscore'
  ], function(ModelManager, ListChooserView, utils, _) {


    $fragment.swFindWithSelf('[data-sw-list-chooser]').each(function() {

      var $el = $(this);

      var configs = $el.swDataParams('swListChooser');
      var selectedOptionTplPropMaps = $el.swDataParams('swListChooserSelectedOptionTplPropMap');
      var dataAttrMap = $el.swDataParams('swListChooserDataAttrMap');

      var model;
      if(!_.isEmpty(configs.swListChooserClientModelType) && !_.isEmpty(configs.swListChooserClientModelId)) {
        model = ModelManager.getModelByTypeAndId(configs.swListChooserClientModelType, configs.swListChooserClientModelId);
      }

      selectedOptionTplPropMaps =  _.isEmpty(selectedOptionTplPropMaps) ? {} : selectedOptionTplPropMaps;
      selectedOptionTplPropMaps = utils.removePrefix('swListChooserSelectedOptionTplPropMap', selectedOptionTplPropMaps);

      dataAttrMap =  _.isEmpty(dataAttrMap) ? {} : dataAttrMap;
      dataAttrMap = utils.removePrefix('swListChooserDataAttrMap', dataAttrMap);

      new ListChooserView({
        el:                           $el,
        model:                        model,
        selectActionType:             configs.swListChooserSelectActionType,
        deselectActionType:           configs.swListChooserDeselectActionType,
        selectedOptionsModelProp:     configs.swListChooserListProperty,
        selectedOptionTemplateName:   configs.swListChooserSelectedOptionTemplate,
        currentOptionsModelProp:      configs.swListChooserCurrentOptionsModelProp,
        disabledClass:                configs.swListChooserDisabledClass,
        chooserUpdatedEvent:          configs.swListChooserChooserUpdatedEvent,
        selectedOptionTplPropMaps:    selectedOptionTplPropMaps,
        dataAttrMap:                  dataAttrMap
      });

    });

  });

};
